import React, { useState } from "react";
import HorizontalTimeline from "react-horizontal-timeline";
import { Fade } from "react-awesome-reveal";
import { useTranslation } from "react-i18next";

import VerticalTimeline from "../VerticalTimeline/VerticalTimeline";

import moment from "moment";
import "moment/locale/fr";

import "./AboutMe.css";

const AboutMe = ({scrollToPortfolio}) => {
  const [value, setValue] = useState(0);
  const { t, i18n } = useTranslation();

  const today = moment().format("YYYY-MM-DD");

  // Utilisation des traductions depuis les fichiers JSON
  const events = t('about.events', { returnObjects: true }).map(event => ({
    ...event,
    end: event.end === 'today' ? today : event.end
  }));

  const dates = events.map((event) =>
    event.type === "date"
      ? moment(event.date).format("MMM YYYY")
      : moment(event.start).format("MMM YYYY")
  );

  const getLabel = (date, index) => {
    const event = events[index];
    const todayLabel = t('about.today');
    const currentLanguage = i18n.language;

    if (event.type === "date") {
      return moment(event.date).locale(currentLanguage).format("MMM YYYY");
    } else if (event.type === "period") {
      const endLabel =
        event.end === today
          ? todayLabel
          : moment(event.end).locale(currentLanguage).format("MMM YYYY");
      return `${moment(event.start)
        .locale(currentLanguage)
        .format("MMM YYYY")} - ${endLabel}`;
    }
  };

  return (
    <div className="container">
      <div className="title">{t('about.title')}</div>
      <div
        className="horizontalTimeline"
        style={{ height: "100px", marginBottom: "30px" }}
      >
        <HorizontalTimeline
          index={value}
          indexClick={(index) => {
            setValue(index);
          }}
          values={dates}
          getLabel={getLabel}
        />
      </div>
      <div className="verticalTimeline">
        <VerticalTimeline events={events} scrollToPortfolio={scrollToPortfolio} />
      </div>
      <div className="event">
        <div className="eventTitle">{events[value].title}</div>
        <div className="eventDate">
          {`${
            events[value].type === "date"
              ? moment(events[value].date).locale(i18n.language).format("MMM YYYY")
              : `${moment(events[value].start)
                  .locale(i18n.language)
                  .format("MMM YYYY")} - ${
                  moment(events[value].end).isSame(moment(), "day")
                    ? t('about.today')
                    : moment(events[value].end).locale(i18n.language).format("MMM YYYY")
                }`
          }`}
        </div>
        <Fade direction="up" cascade key={value} triggerOnce>
          <p className="eventContext">{events[value].context}</p>
          <p className="eventContext">{events[value].context2}</p>
          <div className="tags">
            {events[value].tags &&
              events[value].tags.map((tag, index) => (
                <span key={index} className="tag">
                  {tag}
                </span>
              ))}
          </div>
        </Fade>
      </div>
    </div>
  );
};

export default AboutMe;